/**
 * Adiciona a funcionalidade de focar no equipamento
 * @author: Daniel Laurindo
 * Date: 27/03/14
 * Time: 17:39
 */

import { getResourceTo, toastNotification } from 'react/utils/utils';

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.FocusEquipment = function (selector, map) {

    this.selector = selector;
    this.map = map;

    this.showAlertMessage = function () {
        toastNotification.addToast({
          id: 'focus-equipment-alert',
          type: 'warning',
          variant: 'secondary',
          data: {
            title: getResourceTo('alertgenericmodal.header.title.default'),
            description: getResourceTo('RouteDetail.equipmentFocus.empty'),
          }
        });
    };

    this.goToEquipment = function (marker) {
        (function (m, scope) {
            scope.removeLayerFocus();
            var _latlng;

            if (m._latlng) {
                _latlng = m._latlng;
            } else {
                var _latlngsLast = (m._latlngs.length - 1);
                _latlng = m._latlngs[_latlngsLast];
            }

            var lat    = _latlng.lat,
                lng    = _latlng.lng,
                markerFocusIcon,
                markerFocus,
                latlng = [],
                dismissFocus;

            markerFocusIcon = L.divIcon({
                html: '<div class="greenmileMarkerFocusIcon"></div>',
                iconSize: [50, 50]
            });

            markerFocus = new L.marker([lat, lng], {
                icon: markerFocusIcon,
                zIndexOffset: -1
            });

            markerFocus.kind = "FOCUS";

            m._map.addLayer(markerFocus, true);

            latlng.push([_latlng.lat, _latlng.lng]);
            m._map.fitBounds(latlng);

            dismissFocus = function (marker, scope) {

                scope.map.removeLayer(marker);

            };

            setTimeout((function (marker, scope) {
                return function () {
                    dismissFocus(marker, scope);
                };
            }(markerFocus, scope)), 4000);

        })(marker, this);
    };
    
    this.goToTruck = function () {

        var markers    = this.map._layers,
            Equipement = null,
            Secondary  = null;


        for (var markerId in markers) {
            if (markers[markerId].kind && markers[markerId].kind === "EQUIPMENT") {
                Equipement = markers[markerId];
            } else if (markers[markerId].kind && markers[markerId].kind === "SECONDARY_ROUTE") {
                Secondary = markers[markerId];
            }
        }

        if (Equipement !== null) {
            this.goToEquipment(Equipement);
        } else if (Secondary !== null) {
            this.goToEquipment(Secondary);
        } else {
            this.showAlertMessage();
        }

    };

    this.removeLayerFocus = function () {

        var markers = this.map._layers;

        for (var markerId in markers) {

            if (markers[markerId].kind && markers[markerId].kind === "FOCUS") {

                this.map.removeLayer(markers[markerId]);

            }
        }
    };

    this.addListeners = function () {

        var selector = this.selector;

        $(selector + " .btnFocusEquipment").off();
        $(selector + " .btnFocusEquipment").on("click", (function (scope) {
            return function () {
                scope.goToTruck();
            };
        }(this)));

    };

};
